<ng-container *transloco="let t">
    <h1>{{ t("auth.preferred-language.header") }}</h1>

    @for (language of languages$ | async; track language) {
    <button
        mat-raised-button
        color="primary"
        (click)="chooseLanguage(language)"
        id="{{ 'language-' + language.languageId }}"
    >
        <span>
            {{ language.nativeName | uppercase }}
            <mat-icon>arrow_forward</mat-icon>
        </span>
    </button>
    }
</ng-container>
